import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HasAnyPermissionDirective } from './has-any-permission.directive';
import { HasPermissionDirective } from './has-permission.directive';

@NgModule({
  imports: [CommonModule, HasPermissionDirective, HasAnyPermissionDirective],
  exports: [HasPermissionDirective, HasAnyPermissionDirective],
})
export class PermissionsModule {}
